// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3StMY","header":"ClearentDisclaimer_header__1F6Xt","inner":"ClearentDisclaimer_inner__2FSg6"};